import {Button} from '@/components/ui/button/Button'
import {GoalV3} from '@/features/chat/chat.model'
import {calculatePercentage} from '@/utilities/helpers'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {GoalSuccessStep} from '../goal-success-step/GoalSuccessStep'
import {ShareGoalModal} from '../share-goal-modal/ShareGoalModal'
import {StyledButtonWrapper, StyledDescription, StyledDivider} from './style'

type SuccessDonationGoalProps = {
    onClose: () => void
    goal?: GoalV3
    isFirstDonation: boolean
}
export const SuccessDonationGoal = ({onClose, goal, isFirstDonation}: SuccessDonationGoalProps) => {
    const {t} = useTranslation()
    const [isOpenShareGoalModal, setIsOpenShareGoalModal] = useState(false)
    const percentage =
        !!goal?.donationsCount && !!goal?.targetAmount
            ? calculatePercentage(+goal.donationsCount, +goal?.targetAmount)
            : 0

    return (
        <GoalSuccessStep
            title={t('donation_success_page:title')}
            description={
                <StyledDescription>
                    <p>
                        {isFirstDonation
                            ? t('donation_success_page:subtitle', {
                                  USERNAME: goal?.rookie?.fullName,
                                  context: goal?.rookie?.gender?.keyName
                              })
                            : t('donation_success_page:subtitle_second_support', {
                                  USERNAME: goal?.rookie?.fullName,
                                  context: goal?.rookie?.gender?.keyName
                              })}
                    </p>
                    {percentage < 75 && <p>{t('donation_success_page:description')}</p>}
                </StyledDescription>
            }
        >
            <div>
                <StyledDivider />

                <StyledButtonWrapper>
                    <Button onClick={() => setIsOpenShareGoalModal(true)}>
                        {t('donation_success_page:button_share')}
                    </Button>

                    <Button variant="outlined" onClick={onClose}>
                        {t('donation_success_page:button_close')}
                    </Button>
                </StyledButtonWrapper>
            </div>

            {isOpenShareGoalModal && goal && (
                <ShareGoalModal goal={goal} onClose={() => setIsOpenShareGoalModal(false)} />
            )}
        </GoalSuccessStep>
    )
}
